import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";

const deletePageFailLogic = createLogic({
	type: ActionTypes.DELETE_PAGE_FAILURE,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		const { message } = action.errorMessage;
		dispatch(controlPanelActions.displayError(message));
		done();
	},
});

export default [deletePageFailLogic];
